module.exports = __webpack_public_path__ + "img/20180815_154807_241.0d8f57f5.jpg";